let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9tg3y")).then(() => parcelRequire('brb3w'));